module.exports = __webpack_public_path__ + "media/images/plastika4d-bb22f427.svg";